var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMingcuteInviteLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:invite-line",
    clipPath: "url(#clip0_0_477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6667 4C23.687 3.99994 24.6687 4.38977 25.411 5.08971C26.1534 5.78966 26.6002 6.74681 26.66 7.76533L26.6667 8V13.8L27.4587 13.448C28.2774 13.084 29.2214 13.648 29.3254 14.512L29.3334 14.6667V25.3333C29.3336 26.0061 29.0795 26.6541 28.622 27.1474C28.1646 27.6407 27.5376 27.9429 26.8667 27.9933L26.6667 28H5.33335C4.66059 28.0002 4.0126 27.7461 3.51929 27.2887C3.02598 26.8312 2.72381 26.2042 2.67335 25.5333L2.66669 25.3333V14.6667C2.66669 13.7707 3.56669 13.1373 4.39602 13.3933L4.54269 13.448L5.33335 13.8V8C5.3333 6.97972 5.72312 5.99798 6.42306 5.25565C7.12301 4.51332 8.08016 4.06652 9.09869 4.00667L9.33335 4H22.6667ZM26.6667 16.7187L17.0827 20.9773C16.7418 21.1288 16.373 21.207 16 21.207C15.627 21.207 15.2582 21.1288 14.9174 20.9773L5.33335 16.72V25.3333H26.6667V16.7187ZM22.6667 6.66667H9.33335C8.97973 6.66667 8.64059 6.80714 8.39054 7.05719C8.1405 7.30724 8.00002 7.64638 8.00002 8V14.9853L16 18.5413L24 14.9853V8C24 7.64638 23.8595 7.30724 23.6095 7.05719C23.3594 6.80714 23.0203 6.66667 22.6667 6.66667ZM16 10.6667C16.3399 10.667 16.6667 10.7972 16.9138 11.0305C17.161 11.2638 17.3097 11.5826 17.3296 11.9219C17.3495 12.2611 17.2391 12.5952 17.021 12.8558C16.8029 13.1164 16.4935 13.2839 16.156 13.324L16 13.3333H13.3334C12.9935 13.333 12.6666 13.2028 12.4195 12.9695C12.1724 12.7362 12.0237 12.4174 12.0038 12.0781C11.9839 11.7389 12.0943 11.4048 12.3124 11.1442C12.5305 10.8836 12.8399 10.7161 13.1774 10.676L13.3334 10.6667H16Z",
    fill: "#056E9C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteInviteLine);
export default __webpack_public_path__ + "static/media/mingcute_invite-line.799538983e12efb2e4e38a779b46c310.svg";
export { ForwardRef as ReactComponent };